export const ADD_BOARD = 'ADD_BOARD';
export const REMOVE_BOARD = 'REMOVE_BOARD';
export const SELECT_BOARD = 'SELECT_BOARD';
export const COPY_BOARD = 'COPY_BOARD';
export const CHANGE_BOARD_PROPERTIES = 'CHANGE_BOARD_PROPERTIES';

export const ADD_LINK = 'ADD_LINK';
export const REMOVE_LINK = 'REMOVE_LINK';
export const SELECT_LINK = 'SELECT_LINK';
export const CHANGE_LINK_PROPERTIES = 'CHANGE_LINK_PROPERTIES';

export const SB_CLEAR_SELECTION = 'SB_CLEAR_SELECTION';

export const ADD_VIS_TEMPLATE = 'ADD_VIS_TEMPLATE';
export const REMOVE_VIS_TEMPLATE = 'REMOVE_VIS_TEMPLATE';

export const ADD_BINDING = 'ADD_BINDING';
export const REMOVE_BINDING = 'REMOVE_BINDING';
export const ADD_DECORATION = 'ADD_DECORATION';
export const REMOVE_DECORATION = 'REMOVE_DECORATION';
export const ADD_SCALE = 'ADD_SCALE';
export const REMOVE_SCALE = 'REMOVE_SCALE';

export const ADD_DATA_TICKER = 'ADD_DATA_TICKER';
export const ADD_DATA_SELECTOR = 'ADD_DATA_SELECTOR';
export const ADD_DATA_HIGHLIGHT = 'ADD_DATA_HIGHLIGHT';
export const ADD_DATA_FILTER = 'ADD_DATA_FILTER';

export const ADD_DATASET = 'ADD_DATASET';
export const REMOVE_DATASET = 'REMOVE_DATASET';

export const ADD_GRAPHIC_OBJECT = 'ADD_GRAPHIC_OBJECT';
export const REMOVE_GRAPHIC_OBJECT = 'REMOVE_GRAPHIC_OBJECT';

export const SELECT_TRANSITION = 'SELECT_TRANSITION';

export const UNDO_ACTION = 'UNDO_ACTION';
export const REDO_ACTION = 'REDO_ACTION';

export const BROWSER_RESIZE = 'BROWSER_RESIZE';
